/** Sera — Spirara's business AI assistant (name + product identity). */
export const SERA = {
  id: 'sera',
  name: 'Sera',
  fullName: 'Sera',
  tagline: 'Your business AI',
  description:
    'Sera knows your services, hours, staff and clients — so she can answer messages, draft replies, and surface what needs attention.',
};

export const SERA_STARTERS = [
  'How is the till looking today?',
  'Who still needs a reminder for tomorrow?',
  'Draft a WhatsApp reply for Ada about rescheduling',
  'Which hours were quiet last week?',
];

export const SERA_CHAT = [
  {
    id: 'm1',
    role: 'sera',
    at: '09:12',
    text: 'Morning. You have 8 bookings today — 2 still unconfirmed. Till is at ₦84,500 from 5 completed visits. Want me to nudge the unconfirmed clients on WhatsApp?',
  },
  {
    id: 'm2',
    role: 'user',
    at: '09:14',
    text: 'Yes, send reminders to the unconfirmed ones. Keep the tone warm.',
  },
  {
    id: 'm3',
    role: 'sera',
    at: '09:14',
    text: 'Done. Drafted and queued two WhatsApp reminders for Chioma and Tunde — both for 2pm silk press slots. I used your usual confirmation template and mentioned they can reply here to reschedule.',
  },
  {
    id: 'm4',
    role: 'user',
    at: '09:18',
    text: 'Ada messaged asking if we do knotless braids on Saturday. Can you reply?',
  },
  {
    id: 'm5',
    role: 'sera',
    at: '09:18',
    text: 'Suggested reply ready in Messages → Inbox. Context I used: you offer knotless braids (3 hr 30 min, ₦45,000), Saturday has Amara free from 11am, and Ada last visited 6 weeks ago for a silk press.',
  },
];

export const SERA_CAPABILITIES = [
  {
    title: 'Cross-channel replies',
    body: 'Draft and send answers on WhatsApp, SMS and email with the same business voice.',
  },
  {
    title: 'Floor awareness',
    body: 'Pulls today\u2019s appointments, till totals and open visits when you ask.',
  },
  {
    title: 'Client memory',
    body: 'Uses visit history, preferences and last service so replies feel personal.',
  },
  {
    title: 'Quiet-hour fills',
    body: 'Flags gaps in the calendar and can draft promo messages to fill them.',
  },
];

/** Mock agent settings for the Messages → Sera control. */
export const SERA_AGENT_DEFAULTS = {
  enabled: true,
  autoDraft: true,
  autoSendConfirmations: false,
  tone: 'warm',
  channels: {
    whatsapp: true,
    sms: true,
    email: true,
  },
  useBusinessContext: true,
  useClientHistory: true,
};

export const SERA_TONE_OPTIONS = [
  { id: 'warm', label: 'Warm & personal' },
  { id: 'professional', label: 'Professional' },
  { id: 'brief', label: 'Short & direct' },
];

export const SERA_MENU_SECTIONS = [
  {
    id: 'status',
    title: 'Agent',
    items: [
      { id: 'enabled', label: 'Sera is answering messages', kind: 'toggle', setting: 'enabled' },
      {
        id: 'autoDraft',
        label: 'Auto-draft replies in inbox',
        kind: 'toggle',
        setting: 'autoDraft',
      },
      {
        id: 'autoSendConfirmations',
        label: 'Auto-send booking confirmations',
        kind: 'toggle',
        setting: 'autoSendConfirmations',
      },
    ],
  },
  {
    id: 'channels',
    title: 'Channels',
    items: [
      { id: 'whatsapp', label: 'WhatsApp', kind: 'toggle', settingPath: 'channels.whatsapp' },
      { id: 'sms', label: 'SMS', kind: 'toggle', settingPath: 'channels.sms' },
      { id: 'email', label: 'Email', kind: 'toggle', settingPath: 'channels.email' },
    ],
  },
  {
    id: 'context',
    title: 'Business context',
    items: [
      {
        id: 'useBusinessContext',
        label: 'Use services, hours & pricing',
        kind: 'toggle',
        setting: 'useBusinessContext',
      },
      {
        id: 'useClientHistory',
        label: 'Use client visit history',
        kind: 'toggle',
        setting: 'useClientHistory',
      },
    ],
  },
];
